export function usePathname() {
  return document.location.pathname;
}
